(function(window) {

	var App = function() {

		var getLang = function() {
			return $('html').attr('lang');
		};

		var enableScratchers = function() {

			var distanceBetween = function(point1, point2) {
				return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
			}

			var angleBetween = function(point1, point2) {
				return Math.atan2(point2.x - point1.x,point2.y - point1.y );
			}

			function getFilledInPixels($canvas, ctx) {
				var stride = 32;
				var pixels = ctx.getImageData(0, 0, $canvas.width(), $canvas.height());
				var pdata = pixels.data;
				var l = pdata.length;
				var total = (l / stride);
				var count = 0;

				// Iterate over all pixels
				for(var i = count = 0; i < l; i += stride) {
					if (parseInt(pdata[i]) === 0) {
						count++;
					}
				}

				return Math.round((count / total) * 100);
			}

			var getMouse = function(e, canvas) {
				var offsetX = 0, offsetY = 0, mx, my;

				if (canvas.offsetParent !== undefined) {
					do {
						offsetX += canvas.offsetLeft;
						offsetY += canvas.offsetTop;
					} while ((canvas = canvas.offsetParent));
				}

				mx = (e.pageX || e.touches[0].pageX) - offsetX;
				my = (e.pageY || e.touches[0].pageY) - offsetY;

				return {x: mx, y: my};
			}

			var handleMouseDown = function(e, $canvas) {
				isDrawing = true;
				lastPoint = getMouse(e, $canvas[0]);
			}

			var handleMouseMove = function(e, $canvas, ctx) {
				if (!isDrawing) { return; }

				e.preventDefault();

				var currentPoint = getMouse(e, $canvas[0]);
				var dist = distanceBetween(lastPoint, currentPoint);
				var angle = angleBetween(lastPoint, currentPoint);
				var x, y;

				for (var i = 0; i < dist; i++) {
					x = lastPoint.x + (Math.sin(angle) * i) - 25;
					y = lastPoint.y + (Math.cos(angle) * i) - 25;
					ctx.globalCompositeOperation = 'destination-out';
					ctx.drawImage(brush, x, y);
				}

				lastPoint = currentPoint;
				if (getFilledInPixels($canvas, ctx) > 65) {
					$canvas.fadeOut(200);
				}
			}

			var handleMouseUp = function(e) {
				isDrawing = false;
			}

			var resize = function($canvas, $container, ctx) {
				ctx.clearRect(0, 0, $canvas.width(), $canvas.height());
				$canvas[0].width = $container.width();
				$canvas[0].height = $container.height();
				for (var i = 0; i < images.length; i++) {
					ctx.drawImage(images[$canvas.attr('index')], 0, 0, $container.width(), $container.height());
				}
			};

			var isDrawing, lastPoint;
			var images = [];
			var brush = new Image();

			brush.src = '../images/brush.png';
			
			$('.christmas-tile-scratcher').each(function() {
				var image = new Image();
				image.src = '../images/'+getLang()+'/scratch-me.png';
				images.push(image);
			});
			
			for (var i = 0; i < images.length; i++) {
				images[i].onload = function() {
					$('.christmas-tile-image').each(function(){
						var $promotionImage = $(this);
						$promotionImage.css({'visibility':'visible'});
					});
					$('.christmas-tile-scratcher').each(function() {
						var $canvas = $(this);
						var $container = $canvas.parent();
						var ctx = this.getContext('2d');
	
						resize($canvas, $container, ctx);
						$(window).on('resize', function() {
							resize($canvas, $container, ctx);
						});
						$canvas.on('mousedown', function(e) {
							handleMouseDown(e, $canvas);
						});
						$canvas.on('touchstart',  function(e) {
							handleMouseDown(e, $canvas);
						});
						$canvas.on('mousemove', function(e) {
							handleMouseMove(e, $canvas, ctx);
						});
						$canvas.on('touchmove', function(e) {
							handleMouseMove(e, $canvas, ctx);
						});
						$canvas.on('mouseup', handleMouseUp);
						$canvas.on('touchend', handleMouseUp);
					});
				};
			}
		};

		this.enableScratchers = enableScratchers;

	};

	/* -------------------------------------------------------------------------- */

	$(document).ready(function() {
		app = new App();
		app.enableScratchers();

		window.app = app;

		$(window).trigger('resize');
	});

})(window);
